import {retrieveLaunchParams, openLink as miniAppOpenLink, openTelegramLink} from "@telegram-apps/sdk-react";

export const openExternalLink = (link: string) => {
  const lp = retrieveLaunchParams();
  if (lp.platform != "unknown") {
    if (link.substring(0, 12) === 'https://t.me' || link.substring(0, 4) === 't.me') {
      openTelegramLink(link);
    } else {
      miniAppOpenLink(link, {tryInstantView: false});
    }
  } else {
    window.open(link, '_blank');
  }
}
